import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FilterContextProvider } from './context/filter_context';
import { AppProvider } from './context/product_context';
import 'bootstrap/dist/css/bootstrap.min.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <FilterContextProvider>
          <App />
      </FilterContextProvider>
    </AppProvider>
  </React.StrictMode>
);

